// extracted by mini-css-extract-plugin
export var button = "index-module--button--e83b2";
export var image = "index-module--image--96d20";
export var info = "index-module--info--5438d";
export var wrapper = "index-module--wrapper--a7e54";